export const PurchaseOrdersBaseRoute = '/products/purchaseorders';
